import React, { useMemo, useState } from "react";

const TENOR_OPTIONS = [ "select tenor in " ,2, 3, 4, 5, 6];

const CalculatorModal = ({ isOpen, setIsOpen, amount }) => {
  const [tenor, setTenor] = useState("select tenor in ");

  const toggleModal = () => {
    setTenor("select tenor in ");
    setIsOpen(false);
  };

  const loanAmount = useMemo(() => {
    const parsedAmount = parseFloat((amount || "").toString().replace(/,/g, ""));
    return Number.isNaN(parsedAmount) ? 0 : parsedAmount;
  }, [amount]);

  const monthly = loanAmount > 0 ? loanAmount / tenor : 0;
  const monthlyRepayment = Number.isNaN(monthly) ? 0 : monthly;
  const interestRate = 0;
  const securityDeposit = monthlyRepayment;

  const formatCurrency = (value) =>
    value?.toLocaleString("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-2">
          <div className="relative bg-white p-6 rounded-lg lg:w-[50%] w-[98%] shadow-lg max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-semibold text-[#161032]">
                Monthly Repayment Calculator
              </h2>
              <button
                type="button"
                className="text-gray-500 text-3xl font-bold cursor-pointer hover:text-black leading-none"
                onClick={toggleModal}
              >
                &times;
              </button>
            </div>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <p className="text-sm text-gray-500 mb-2">Loan Amount</p>
                <p className="text-3xl font-bold text-[#161032]">
                  {formatCurrency(loanAmount)}
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  This amount is pulled directly from the home page amount field.
                </p>
              </div>

              <div>
                <label
                  htmlFor="loan-tenor"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Select Loan Tenor
                </label>
                <select
                  id="loan-tenor"
                  value={tenor}
                  onChange={(e) => setTenor(Number(e.target.value))}
                  className="w-full h-12 rounded-lg border border-gray-300 px-4 outline-none focus:border-[#161032]"
                >
                  {TENOR_OPTIONS.map((option) => (
                    <option key={option} value={option}>
                      {option} {option === 1 ? "month" : "months"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="bg-[#161032] rounded-lg p-5 text-white">
                <p className="text-sm text-white/80 mb-2">Monthly Repayment</p>
                <p className="text-3xl font-bold">
                  {formatCurrency(monthlyRepayment)}
                </p>
                {/* <p className="text-sm text-white/80 mt-2">
                  Calculation: amount divided by number of months.
                </p> */}
              </div>

              <div className="grid gap-4 md:grid-cols-2">
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <p className="text-sm text-gray-500 mb-2">Interest Rate</p>
                  <p className="text-2xl font-bold text-[#161032]">{interestRate}%</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <p className="text-sm text-gray-500 mb-2">Security Deposit</p>
                  <p className="text-2xl font-bold text-[#161032]">
                    {formatCurrency(securityDeposit)}
                  </p>
                  <p className="text-sm text-gray-500 mt-2">
                    Equivalent to one month repayment.
                  </p>
                </div>
              </div>

              <div className="rounded-lg border border-[#161032]/15 bg-[#161032]/5 p-4">
                <p className="text-sm text-[red] font-bold">
                  You are required to pay a security deposit amount of{" "}
                  {formatCurrency(securityDeposit)} which is equivalent to one
                  month repayment of your premium financing. The security
                  deposit will be refunded after full repayment of your loan or
                  it will be used for settlement of one month repayment
                  default, if any.
                </p>
              </div>

              {loanAmount <= 0 && (
                <p className="text-sm text-red-500">
                  Enter a valid amount on the home page to see your repayment.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalculatorModal;
